import {
  VuexModule, Module, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import store from '@/store';

const convertHexToRGBA = (hexCode: string, opacity: number) => {
  let hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${opacity / 100})`;
};

const darkenColor = (color: string, percent: number) => {
  // eslint-disable-next-line no-param-reassign
  if (percent < 0) percent = 0;
  // eslint-disable-next-line no-param-reassign
  if (percent > 1) percent = 1;

  // Разбиваем цвет на красный, зеленый и синий компоненты
  let r = parseInt(color.slice(1, 3), 16);
  let g = parseInt(color.slice(3, 5), 16);
  let b = parseInt(color.slice(5, 7), 16);

  // Уменьшаем яркость каждого компонента
  r *= (1 - percent);
  g *= (1 - percent);
  b *= (1 - percent);

  // Преобразуем обновленные значения обратно в шестнадцатеричный формат
  const newColor = `#${Math.round(r).toString(16)}${Math.round(g).toString(16)}${Math.round(b).toString(16)}`;

  return newColor;
};

export interface IColorState {
  basicColor: {
    color_1: any // jc_color
    color_2: any // jc_active_tab_color
  }
}

@Module({ dynamic: true, store, name: 'color' })
class Color extends VuexModule implements IColorState {
  public basicColor = {
    color_1: '#bf1e2e',
    color_2: '#334955',
    color_1_filter: '',
    color_2_filter: '',
    color_1_rgba: '',
    color_2_rgba: '',
  };

  @Mutation
  private SET_COLOR(payload: any) {
    const { color_1, color_2 } = payload;

    if (color_1) {
      this.basicColor.color_1 = `#${color_1}`;
      this.basicColor.color_1_filter = darkenColor(this.basicColor.color_1, 0.2);
      this.basicColor.color_1_rgba = convertHexToRGBA(this.basicColor.color_1, 50);
    }
    if (color_2) {
      this.basicColor.color_2 = `#${color_2}`;
      this.basicColor.color_2_filter = darkenColor(this.basicColor.color_2, 0.2);
      this.basicColor.color_2_rgba = convertHexToRGBA(this.basicColor.color_2, 50);
    }
  }

  @Mutation
  private SET_COLOR_SID(payload: any) {
    // const { sid } = payload;
  }

  @Action
  public SetColor(payload: any) {
    this.SET_COLOR(payload);
  }

  @Action
  public SetColorSid(payload: any) {
    this.SET_COLOR_SID(payload);
  }
}

export const ColorModule = getModule(Color);
